import React from 'react';
import styled from 'styled-components';

const ModalTextArea = styled.textarea`
    height: 150px;
    width: 98%;
    border: 1px solid #ffffff;
    border-radius: 3px;
    background-color:#ffffff
    box-shadow: 0 0 4px #c4c4c4;
    resize: none;
    padding: 5px;
    font-size: 14px;
    font-family: Montserrat,sans-serif;
    color: ${process.env.DEFAULT_TEXT_COLOR};
`;

class CSLTextArea extends React.Component
{
    state = {value: ""};

    componentDidMount() {
        this.setState({value: this.props.value});
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state !== nextState) {
            return true;
        } else {
            return false;
        }
    }

    componentDidUpdate(nextProps) {
        console.log("Text input updated");
    }

    handleChange = (event) => {
        event.preventDefault();
        this.setState({value: event.target.value});
        // const obj = {name: this.props.name, value: event.target.value};
        // this.props.handleTextChange(obj);
    }

    synchronizeHoc = (event) => {
        event.preventDefault();
        const obj = {entity: this.props.entity, name: this.props.name, value: this.state.value};
        this.props.handleTextChange(obj);
    }

    render() {
        return (
            <ModalTextArea id={this.props.id} value={this.state.value} onChange={this.handleChange} onBlur={this.synchronizeHoc}></ModalTextArea>
        );
    }
}

export default CSLTextArea;
